{
  "productClassList": [],
  "markupConditionList": [],  
  "marketList": [],
  "showOnlyValidMarkupPercentages": true,
  "markupPercentagePaging": {
    "offset": 50,
    "page": 1
  },
  "markupPercentageTotalCount": 0,
  "markupPercentageListSortExpression":null,
  "markupPercentageListFilterExpression":null,
  "markupPercentageList":[]
}
